var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMethodWhatsapp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2041 5.76108C16.5581 4.11408 14.3691 3.20608 12.0371 3.20508C7.23014 3.20508 3.31914 7.11408 3.31814 11.9191C3.31614 13.4481 3.71714 14.9511 4.48114 16.2761L3.24414 20.7921L7.86614 19.5801C9.14514 20.2761 10.5771 20.6411 12.0331 20.6411H12.0371C16.8421 20.6411 20.7531 16.7311 20.7551 11.9261C20.7561 9.59808 19.8501 7.40908 18.2041 5.76108Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0952 13.5599L13.5012 13.1569C13.8742 12.7869 14.4642 12.7399 14.8942 13.0419C15.3102 13.3339 15.6862 13.5959 16.0362 13.8399C16.5922 14.2259 16.6592 15.0179 16.1802 15.4959L15.8212 15.8549",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14502 8.17841L8.50402 7.81941C8.98202 7.34141 9.77402 7.40841 10.16 7.96341C10.403 8.31341 10.665 8.68941 10.958 9.10541C11.26 9.53541 11.214 10.1254 10.843 10.4984L10.44 10.9044",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8212 15.8553C14.3402 17.3293 11.8512 16.0773 9.88623 14.1113",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88807 14.1127C7.92307 12.1467 6.67107 9.65873 8.14507 8.17773",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4399 10.9043C10.7589 11.4073 11.1679 11.9053 11.6299 12.3673L11.6319 12.3693C12.0939 12.8313 12.5919 13.2403 13.0949 13.5593",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMethodWhatsapp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/method-whatsapp.82c7d010299113a4191209f05b4daf58.svg";